import { render, staticRenderFns } from "./FormControlPagesTemplateId.vue?vue&type=template&id=c92b15da"
import script from "./FormControlPagesTemplateId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlPagesTemplateId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports